module.exports = __webpack_public_path__ + "img/juega-bien.2f84a871.png";